var map = {
	"./dark_SocialsInOne_fav.png": 620,
	"./dark_SocialsInOne_logo.png": 621,
	"./dark_bg-login.svg": 622,
	"./dark_dashboard_bg.jpg": 623,
	"./dark_dataak_fav.png": 624,
	"./dark_dataak_headlogo.svg": 625,
	"./dark_dataak_logo.svg": 626,
	"./dark_digitalMarketing_bg.jpg": 627,
	"./dark_irancell_labz_bg_login.svg": 628,
	"./dark_irancell_labz_favicon.png": 629,
	"./dark_irancell_labz_header_logo.svg": 630,
	"./dark_irancell_labz_logo.svg": 631,
	"./dark_kafir_fav.png": 632,
	"./dark_kafir_headlogo.png": 633,
	"./dark_manshour_fav.png": 634,
	"./dark_manshour_logo.png": 635,
	"./dark_matin_fav.png": 636,
	"./dark_matin_logo.png": 637,
	"./dark_mokhtar_fav.png": 638,
	"./dark_mokhtar_logo.png": 639,
	"./dark_pr_bg.jpg": 640,
	"./light_SocialsInOne_fav.png": 641,
	"./light_SocialsInOne_logo.png": 642,
	"./light_bg-login.svg": 643,
	"./light_dashboard_bg.jpg": 644,
	"./light_dataak_fav.png": 645,
	"./light_dataak_headlogo.svg": 646,
	"./light_dataak_logo.svg": 647,
	"./light_digitalMarketing_bg.jpg": 648,
	"./light_irancell_labz_bg_login.svg": 649,
	"./light_irancell_labz_favicon.png": 650,
	"./light_irancell_labz_header_logo.svg": 651,
	"./light_irancell_labz_logo.svg": 652,
	"./light_kafir_fav.png": 653,
	"./light_kafir_headlogo.png": 654,
	"./light_manshour_fav.png": 655,
	"./light_manshour_logo.png": 656,
	"./light_matin_fav.png": 657,
	"./light_matin_logo.png": 658,
	"./light_mokhtar_fav.png": 659,
	"./light_mokhtar_logo.png": 660,
	"./light_pr_bg.jpg": 661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1136;